import React, { Suspense, lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const EmailPhonePreferences = lazy(
  () =>
    import(
      '@pages/dashboard/DataAndCommunication/components/EmailPhonePreferences'
    ),
);

const GoPaperless = lazy(
  () => import('@pages/dashboard/DataAndCommunication/components/GoPaperless'),
);
const SeeMyData = lazy(
  () => import('@pages/dashboard/DataAndCommunication/components/SeeMyData'),
);

export const DataAndCommunicationRoutes: RouteObject = {
  handle: {
    label: 'Data & Communication',
    skipBreadCrumb: true,
  },
  children: [
    {
      path: '/dashboard/email-phone-preferences',
      handle: {
        label: 'Email & Phone Preferences',
        disabled: true,
      },
      element: (
        <Suspense>
          <EmailPhonePreferences />
        </Suspense>
      ),
    },
    {
      path: '/dashboard/go-paperless',
      handle: {
        label: 'Go Paperless',
        disabled: true,
      },
      element: (
        <Suspense>
          <GoPaperless />
        </Suspense>
      ),
    },
    {
      path: '/dashboard/see-my-data',
      handle: {
        label: 'See my data',
        disabled: true,
      },
      element: (
        <Suspense>
          <SeeMyData />
        </Suspense>
      ),
    },
  ],
};
